import React, { useState, useCallback } from "react";
import { Line } from "react-chartjs-2";

import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import makeStyles from "@material-ui/core/styles/makeStyles";

import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import SearchIcon from "@material-ui/icons/Search";

import NotFound from "components/Texts/NotFound";
import UtilsFncs from "utils/UtilsFncs";
import FromToDateField from "components/_refactor/fields/from-to-date";

const useStyles = makeStyles({
  toggle: {
    textTransform: "capitalize",
  },
  selected: {
    fontWeight: "bold",
  },
});

const today = new Date();
const data7dias = new Date(today.setDate(today.getDate() - 8))
  .toISOString()
  .slice(0, 10);

const yesterday = new Date(today.setDate(new Date().getDate() - 1))
  .toISOString()
  .slice(0, 10);

const getHorizontalLabels = (indicators) => {
  const labels = indicators?.map((indicator) => indicator.Data);

  return labels;
};

const getEvolucaoDatasets = (indicators) => {
  const datasets = [
    {
      label: "Visitas",
      data: indicators?.map((dataIndicators) => dataIndicators.Visitas),
      borderColor: "rgba(58, 175, 133, 0.9)",
      backgroundColor: "rgba(58, 175, 133, 0.9)",
      fill: false,
      yAxisID: "A",
    },
    {
      label: "Tickets",
      data: indicators?.map((dataIndicators) => dataIndicators.Tickets),
      borderColor: "rgba(28, 52, 93, 0.4)",
      backgroundColor: "rgba(28, 52, 93, 0.4)",
      yAxisID: "A",
      fill: false,
    },
    {
      label: "Taxa de Conversão",
      data: indicators.map(
        (dataIndicators) => dataIndicators.TaxaConversaoNumero
      ),
      borderColor: "rgba(223, 118, 125, 0.9)",
      backgroundColor: "rgba(223, 118, 125, 0.9)",
      yAxisID: "B",
      fill: false,
    },
  ];

  return datasets;
};

export default function EvolutionIndicators({
  indicators,
  pesquisar,
  searching,
  lastIndicatorsParams,
  isMobile,
}) {
  const classes = useStyles();
  const [periodo, setPeriodo] = useState(
    lastIndicatorsParams?.dtIni || lastIndicatorsParams?.dtFim
      ? "periodo"
      : "ano"
  );
  const [dimensao, setDimensao] = useState(
    lastIndicatorsParams?.dimensao || "diario"
  );
  const [dataInicial, setDataInicial] = React.useState(
    lastIndicatorsParams?.dtIni
      ? UtilsFncs.ConvertDateFormat(lastIndicatorsParams.dtIni, "-", "/")
      : UtilsFncs.GetMoment(data7dias).format("DD/MM/YYYY")
  );
  const [dataFinal, setDataFinal] = React.useState(
    lastIndicatorsParams?.dtFim
      ? UtilsFncs.ConvertDateFormat(lastIndicatorsParams.dtFim, "-", "/")
      : UtilsFncs.GetMoment(yesterday).format("DD/MM/YYYY")
  );

  const handlePeriodo = useCallback(
    (event, novoPeriodo) => {
      if (novoPeriodo === "ano" || novoPeriodo !== periodo) {
        setDataInicial(UtilsFncs.GetMoment(data7dias).format("DD/MM/YYYY"));
        setDataFinal(UtilsFncs.GetMoment(yesterday).format("DD/MM/YYYY"));
      }

      setPeriodo(novoPeriodo);
    },
    [periodo]
  );

  const handledimensao = useCallback((event, novaDimensao) => {
    setDimensao(novaDimensao);
  }, []);

  const handleConsulta = useCallback(async () => {
    const isAnnual = periodo === "ano";

    const params = {
      isAnnual,
      dtIni: isAnnual
        ? `${today.getFullYear()}-01-01`
        : UtilsFncs.ConvertDateFormat(dataInicial, "/", "-"),
      dtFim: isAnnual
        ? UtilsFncs.TodayDate()
        : UtilsFncs.ConvertDateFormat(dataFinal, "/", "-"),
      dimensao,
    };

    await pesquisar(params, true);
  }, [dataFinal, dataInicial, dimensao, periodo, pesquisar]);

  return (
    <>
      <Card>
        <CardHeader
          subheader={
            <Grid
              container
              component={Box}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs="auto">
                <Box
                  component={Typography}
                  variant="h2"
                  marginBottom="0!important"
                >
                  <Box component="span">
                    Evolução de Indicadores - Comportamento Taxa de Conversão
                  </Box>
                </Box>
              </Grid>
            </Grid>
          }
        />
        <CardContent>
          <Grid container>
            <Grid
              item
              xs={isMobile ? 12 : 6}
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              <FormGroup>
                <ToggleButtonGroup
                  value={periodo}
                  exclusive
                  onChange={handlePeriodo}
                  size="small"
                  aria-label="filtro de periodo de Evoluçao Indicadores"
                >
                  <ToggleButton
                    value="ano"
                    aria-label="periodo ano"
                    classes={{
                      selected: classes.selected,
                      root: classes.toggle,
                    }}
                  >
                    Ano Atual
                  </ToggleButton>
                  <ToggleButton
                    value="periodo"
                    aria-label="periodo customizavel"
                    classes={{
                      selected: classes.selected,
                      root: classes.toggle,
                    }}
                  >
                    Período
                  </ToggleButton>
                </ToggleButtonGroup>
              </FormGroup>
              {periodo === "periodo" && (
                <FromToDateField
                  label="Período"
                  disabled={searching}
                  initialDate={dataInicial}
                  finalDate={dataFinal}
                  setInitialDate={setDataInicial}
                  setFinalDate={setDataFinal}
                  isMobile={isMobile}
                />
              )}
            </Grid>
            <Grid
              item
              xs={isMobile ? 12 : 6}
              style={{
                display: "flex",
                justifyContent: isMobile ? "flex-start" : "flex-end",
                flexDirection: isMobile ? "column" : "row",
                alignItems: "flex-start",
              }}
            >
              <FormGroup>
                <ToggleButtonGroup
                  value={dimensao}
                  exclusive
                  onChange={handledimensao}
                  size="small"
                  aria-label="filtro de dimensão da evolução de indicadores - Comportamento Taxa de Conversão"
                >
                  <ToggleButton
                    value="mensal"
                    aria-label="dimensão mensal da evolução de indicadores - Comportamento Taxa de Conversão"
                    classes={{
                      selected: classes.selected,
                      root: classes.toggle,
                    }}
                  >
                    Mensal
                  </ToggleButton>
                  <ToggleButton
                    value="dia semana"
                    aria-label="dimensão de dia da semana da evolução de indicadores - Comportamento Taxa de Conversão"
                    classes={{
                      selected: classes.selected,
                      root: classes.toggle,
                    }}
                  >
                    Dia Semana
                  </ToggleButton>
                  <ToggleButton
                    value="diario"
                    aria-label="dimensão diária da evolução de indicadores - Comportamento Taxa de Conversão"
                    classes={{
                      selected: classes.selected,
                      root: classes.toggle,
                    }}
                  >
                    Diário
                  </ToggleButton>
                </ToggleButtonGroup>
              </FormGroup>
              <Button
                variant="contained"
                onClick={handleConsulta}
                disabled={searching}
                startIcon={<SearchIcon style={{ width: 18, height: 18 }} />}
                style={{ display: "flex", marginLeft: isMobile ? "0" : "1rem" }}
              >
                {searching ? "Consultando..." : "Consultar"}
              </Button>
            </Grid>
            <Grid item xs={12} style={{ marginTop: isMobile ? "1rem" : 0 }}>
              {indicators.length > 0 ? (
                <Box position="relative" height="350px">
                  <Line
                    data={{
                      labels: getHorizontalLabels(
                        indicators,
                        lastIndicatorsParams.dimensao
                      ),
                      datasets: getEvolucaoDatasets(indicators),
                    }}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      scales: {
                        yAxes: [
                          {
                            id: "A",
                            type: "linear",
                            position: "left",
                          },
                          {
                            id: "B",
                            type: "linear",
                            position: "right",
                            ticks: {
                              max: 100,
                              min: 0,
                            },
                          },
                        ],
                      },
                    }}
                  />
                </Box>
              ) : (
                <NotFound title="Não foram encontrados dados para Evolução Indicadores." />
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
